import type { BreadcrumbType } from '@bugsnag/js';

const SAFE_BREADCRUMB_TYPES: BreadcrumbType[] = [
	'navigation',
	'request',
	'process',
	'user',
	'state',
	'error',
	'manual',
];

/**
 * Returns the BugSnag breadcrumb types that are safe to collect in every
 * monitored release stage.
 *
 * Console log breadcrumbs are deliberately excluded because their free-form
 * messages and serialized arguments cannot be reliably redacted.
 */
export default function getBugsnagBreadcrumbTypes(): BreadcrumbType[] {
	return [...SAFE_BREADCRUMB_TYPES];
}
